import styled from 'styled-components';

export const MasterContainer = styled.section`
  display: flex;
  position: relative;
`;

export const MobileMasterContainer = styled.section`
  margin-left: -24px;
  margin-right: -24px;
`;

export const NoResultsContainer = styled.section`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
`;

export const ScrollAlertWindow = styled.div`
  position: absolute;
  top: 20px;
  left: calc(50% - 100px);
  height: 213px;
  width: 196px;
  border-radius: 4px;
  background-color: rgba(42, 42, 51, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ScrollAlertIcons = styled.div`
  width: 116px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const ScrollAlertWindowMobile = styled.div`
  position: absolute;
  top: 20px;
  left: calc(50% - 104px);
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 208px;
  width: 208px;
  border-radius: 4px;
  background-color: rgba(42, 42, 51, 0.9);
`;

export const ScrollAlertIconsMobile = styled.div`
  display: flex;
  width: 160px;
  margin-bottom: 16px;
  justify-content: space-between;
`;

export const ScrollAlertIconArrow = styled.div`
  margin-top: 24px;
`;

export const ScrollAlertIconPointer = styled.div`
  margin-top: 40px;
`;

export const Item = styled.article`
  cursor: pointer;
  flex: 0 0 auto;
  margin: 0 4px;
`;

export const ButtonsContainer = styled.div`
  height: inherit;
  min-width: 48px;
  text-align: center;
`;

export const Buttons = styled.div`
  position: relative;
  top: 56px;
  cursor: pointer;
`;

export const HomeButton = styled.div`
  position: relative;
  text-align: center;
  cursor: pointer;
  top: 24px;
`;

export const MobileHomeButtonLeft = styled.div`
  position: absolute;
  text-align: center;
  top: -58px;
  left: 24px;
  cursor: pointer;
`;

export const MobileHomeButtonRight = styled.div`
  position: absolute;
  text-align: center;
  top: -58px;
  right: 24px;
  cursor: pointer;
`;

export const LabelContainer = styled.div`
  margin-top: 23px;
  margin-bottom: 8px;
`;

export const InputContainer = styled.div`
  margin-bottom: 67px;
`;
